import axios from '@axios'

const BASE = '/onboarding'

export default {
  getStatus: () => axios.get(`${BASE}/status`),
  startTrial: (withDemoData = true) =>
    axios.post(`${BASE}/start-trial`, { with_demo_data: withDemoData }),
  goLive: () => axios.post(`${BASE}/go-live`),
  checkoutFee: (paymentChannel) => axios.post(`${BASE}/checkout-fee`, { payment_channel: paymentChannel }),
  getFeeTransaction: () => axios.get(`${BASE}/fee-transaction`),
  getFeeTransactionStatus: (txId) => axios.get(`${BASE}/fee-transaction/${txId}/status`),
}
